export default __webpack_public_path__ + "static/Hero-77d064c4e8970362bc96a761d06fac19.png";